<div style="float: left; width: 100%; height: 100%; text-align: center;">
  <div style="width: 1024px; display: inline-block;">
    <app-camera index="1" [video]="devices[0]"></app-camera>
    <app-camera index="2" [video]="devices[1]"></app-camera>
    <app-camera index="3" [video]="devices[2]"></app-camera>
    <app-camera index="4" [video]="devices[3]"></app-camera>
  </div>
</div>
